
























































































































































import {Vue, Component, PropSync, Watch} from 'vue-property-decorator';
import proxySettingsForm from "@/pages/Pages/Push/proxySettingsForm.vue";
import {SelectWings, InputWings} from "wings-ui-components";
import {FcmType} from "@/store/push/application/types";

@Component({components: {SelectWings, proxySettingsForm, InputWings}})
export default class FCMComponent extends Vue {
  @PropSync('fcmOptions') fcm!: FcmType;
  @PropSync('filesOptions') files!: { file: File, type: string }[];

  private serverTypeList: string[] = ['PRODUCTION', 'DEVELOPMENT', 'SIMULATOR']
  private isProxySettings: boolean = false;

  onFilePicked(file: File, type?: string | null) {
    if (!type) return;
    this.files?.push({file: file, type: type});
  }

  created() {
    if(this.fcm.proxy_settings_name) this.isProxySettings = true;
  }

  @Watch('isProxySettings')
  onChangeProxy(newValue: boolean) {
    if (!newValue) this.fcm.proxy_settings_id = undefined;
  }

  // @Watch('fcm.server_type')
  // onChangeOptions(newValue: string) {
  //   if (newValue == 'SIMULATOR') {
  //     this.fcm.fcm_key = null
  //     this.fcm.sender_id = null
  //     this.fcm.connection_count = null
  //     this.fcm.service_account_path = null
  //   } else {
  //     this.fcm.ip = null
  //     this.fcm.port = null
  //   }
  // }

}
